"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// import { IOrderPayment } from '../types/Order'
/**
 * 將 APP 格式的 payment 轉換至 API 需要的格式
 * @deprecated
 */
function appPaymentToApiPayment(appPayment) {
    return undefined;
    // const paidAmount = Number(appPayment.paidAmount)
    // const paymentTips = Number(appPayment.paymentTips)
    // return {
    //   id: appPayment.id,
    //   paymentMethod: appPayment.paymentMethod,
    //   paymentCharge: appPayment.paymentCharge,
    //   payload: appPayment.payload,
    //   gateway: appPayment.gateway,
    //   ref: appPayment.ref,
    //   amount: appPayment.amount,
    //   paidAmount: paidAmount,
    //   paymentTips: paymentTips,
    //   change: paidAmount - appPayment.amount + paymentTips,
    //   remark: appPayment.remark,
    //   status: appPayment.status,
    // }
}
exports.default = appPaymentToApiPayment;
//# sourceMappingURL=appPaymentToApiPayment.js.map